import styled, { css } from 'styled-components';
import theme from '../../../assets/styles/theme';

export const TableFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${theme.colors.neutral.bg.regular};
  border-radius: 0px 0px ${theme.borderRadius['border-radius-4']}
    ${theme.borderRadius['border-radius-4']};
  padding: ${theme.spacing['spacing-4']} ${theme.spacing['spacing-7']};
  margin-bottom: ${theme.spacing['spacing-3']};
`;

export const LeftContent = styled.div`
  span {
    margin-right: ${theme.spacing['spacing-9']};
  }
`;

export const RightContent = styled.div``;
export const TableCheckbox = styled.div`
  display: flex;
  justify-content: center;
`;
